import { downgradeComponent } from '@angular/upgrade/static';
import angular from 'angular';
import { VideoReviewersComponent } from './video-reviewers.component';

export const videoReviewersModule = angular.module('videoReviewersModule', [])
	.directive('videoReviewers', downgradeComponent({ component: VideoReviewersComponent }))
	.name;
